import UCrypto from "@repo/utils/UCrypto";

import { scriptSrc } from "~/analytics/utils";
import appSettings from "~/appSettings";
import { useUser } from "~/state/features/user";

import { Registration } from "../../client";

declare global {
  interface Window {
    ire(...args: any): void;
  }
}

export default (): Registration.Conversion => {
  if (import.meta.env.APP_ENV !== "production") return;

  // prettier-ignore
  // @ts-expect-error
  // eslint-disable-next-line
  !function(a,b,c,d,e,f,g){e['ire_o']=c;e[c]=e[c]||function(){(e[c].a=e[c].a||[]).push(arguments)};f=d.createElement(b);g=d.getElementsByTagName(b)[0];f.async=1;f.src=a;g.parentNode.insertBefore(f,g);}(scriptSrc('https://utt.impactcdn.com/A3114293-8621-4f1d-b7bd-39df372f1b2e1.js'),'script','ire',document,window);

  // Must identify immediately, even if unauthenticated
  window.ire("identify", { customerId: "", customerEmail: "" });

  return {
    async identify({ userId }) {
      if (!userId) return;

      const [user] = useUser();

      const emailHash = await UCrypto.sha256Hex(user.pii()!.email);
      window.ire("identify", {
        customerId: userId,
        customerEmail: emailHash,
      });
    },
    async track(name, properties) {
      const [user] = useUser();

      const trackingId =
        appSettings.marketing.impactRadius.trackingIdByConversionEvent[name];

      if (!trackingId) return;

      window.ire(
        "trackConversion",
        trackingId,
        {
          customerId: user.id(),
          customerEmail: await UCrypto.sha256Hex(user.pii()!.email),
          orderId: properties.accountId,
        },
        {
          verifySiteDefinitionMatch: true,
        }
      );
    },
  };
};
